import { MultipleChoice } from '../types';

// QuestionTypes now lives in libs/core (libs/core/src/enums/question-type.ts)
// and is re-exported here so existing app-side importers keep working while the
// dependency edge stays app -> libs.
export { QuestionTypes } from '@celito.clients/enums';

// export const checkedSelectedValue: string[] = [];
export const checkedSelectedValue: MultipleChoice = {
  multipleChoice: [],
};
export const apiChoicesList: MultipleChoice = {
  multipleChoice: [],
};
export const radioSelectedValue: MultipleChoice = {
  multipleChoice: [],
};

export const choiceSelectedValue: MultipleChoice = {
  multipleChoice: [],
};

export const feedbackObj: any = {
  obj: {},
};
